import { TAB_IDS, tabs_button } from '../assets/data'
import { viewTabPermission } from './permissions'
import { computeVisiblePatientTabItems, getCaseTypeTabConfig } from './patientTabVisibility'

export const NEGOTIATION_NOTE_TYPE_ID = TAB_IDS.NEGOTIATION

const hasViewPermission = (value) => value === true || value === 1 || value === '1'

export function hasNegotiationViewPermission(permissions) {
    return hasViewPermission(permissions?.negotiation_view)
}

export function filterNoteTypesByPermission(options, permissions) {
    if (!Array.isArray(options)) {
        return options
    }
    if (hasNegotiationViewPermission(permissions)) {
        return options
    }
    return options.filter((item) => item?.value != NEGOTIATION_NOTE_TYPE_ID && item?.id != NEGOTIATION_NOTE_TYPE_ID)
}

export function filterNotesByPermission(notes, permissions) {
    if (!Array.isArray(notes)) {
        return notes
    }
    if (hasNegotiationViewPermission(permissions)) {
        return notes
    }
    return notes.filter((item) => item?.note_type_id != NEGOTIATION_NOTE_TYPE_ID)
}

function hasAnyViewFlag(permissions) {
    return !!permissions && Object.keys(permissions).some((key) => key.endsWith('_view'))
}

/** Same permission source PatientTabs uses before it decides which case tabs to show. */
export function effectiveViewPermissions(userPermissions, editPermissions) {
    if (hasAnyViewFlag(userPermissions)) {
        return userPermissions
    }
    if (hasAnyViewFlag(editPermissions)) {
        return editPermissions
    }
    return null
}

/** True when the Notes/Tasks tab would be available on this case for this user. */
export function canSeeCaseNotesTab(userPermissions, editPermissions, activeCase) {
    const permissions = effectiveViewPermissions(userPermissions, editPermissions)
    if (!permissions) {
        return false
    }
    const notesTab = tabs_button.find((item) => item.id === TAB_IDS.NOTES || item.tab === 'notes')
    if (!notesTab) {
        return false
    }
    const matches = viewTabPermission([notesTab], permissions)
    if (!Array.isArray(matches) || !matches.some((item) => item.tab === 'notes')) {
        return false
    }
    if (!activeCase?.case?.case_type_id) {
        return true
    }
    const foundItem = getCaseTypeTabConfig(activeCase)
    if (!foundItem) {
        return true
    }
    const visible = computeVisiblePatientTabItems({
        activeCase,
        permission_tabs: matches,
        foundItem,
    })
    return visible.some((item) => item.tab === 'notes')
}

export function canUseNoteTypeId(noteTypeId, permissions) {
    if (noteTypeId == null) {
        return true
    }
    if (noteTypeId != NEGOTIATION_NOTE_TYPE_ID) {
        return true
    }
    return hasNegotiationViewPermission(permissions)
}
